
export default {
    name: 'LeeImgContrast',
    data() {
        return {
            thedirection:'',
            fullw: 0,
            posx: 0,
            down: false,
            oldx: 0,
            savex: 0
        }
    },
    watch: {
        direction: {
            immediate: true,
            handler(value) {
                let types=['horizontal','vertical']
                let fi=types.filter(function(el) {
                    return el.indexOf(value)>-1;
                })
                if(fi.length<1){
                    this.thedirection="horizontal"
                }else{
                    this.thedirection=value
                }
            }
        },
    },
    methods: {
        chuli() {
            if (this.oldx === 0) {//并且没有滑动过
                this.posx = 50
                this.savex = this.posx
            }
            document.addEventListener('mousedown', (e) => {
                e.preventDefault()
            })
            document.addEventListener('mousemove', (e) => {
                let mm;
                if (this.thedirection === 'horizontal') {
                    mm = Math.round((e.pageX - this.oldx) / this.fullw * 100)
                } else {
                    mm = Math.round((e.pageY - this.oldx) / this.fullw * 100)
                }

                if (this.down) {
                    this.posx = this.savex + mm
                    if (this.posx >= 100) {
                        this.posx = 100
                    }
                    if (this.posx <= 0) {
                        this.posx = 0
                    }
                }
            })
            document.addEventListener('mouseup', (e) => {
                this.down = false
                this.savex = this.posx
            })
            document.addEventListener('touchmove', (e) => {
                let mm;
                if (this.thedirection === 'horizontal') {
                    mm = Math.round((e.targetTouches[0].pageX - this.oldx) / this.fullw * 100)
                } else {
                    mm = Math.round((e.targetTouches[0].pageY - this.oldx) / this.fullw * 100)
                }
                if (this.down) {
                    this.posx = this.savex + mm
                    if (this.posx >= 100) {
                        this.posx = 100
                    }
                    if (this.posx <= 0) {
                        this.posx = 0
                    }
                }

            })
            document.addEventListener('touchend', (e) => {
                this.down = false
                this.savex = this.posx
            })
        },
        mousedown() {
            this.down = true
            if (this.thedirection === 'horizontal') {
                this.oldx = event.pageX
            } else {
                this.oldx = event.pageY
            }
        },
        touchstart() {
            this.down = true
            if (this.thedirection === 'horizontal') {
                this.oldx = event.targetTouches[0].pageX
            } else {
                this.oldx = event.targetTouches[0].pageY
            }

        },
        left() {
            let lst = setInterval(() => {
                this.posx--
                if (this.posx <= 0) {
                    this.posx = 0
                    this.savex=0
                    clearInterval(lst)
                }
            }, 10)
        },
        right() {
            let rst = setInterval(() => {
                this.posx++
                if (this.posx >= 100) {
                    this.posx = 100
                    this.savex=100
                    clearInterval(rst)
                }
            }, 10)
        }
    },
    mounted() {
        let sel = this.$refs.contrast
        let ww = sel.offsetWidth
        let img = new Image()
        img.src = sel.querySelector('img').src
        img.onload = () => {
            if (this.thedirection === 'horizontal') {
                this.fullw = ww
            } else {
                this.fullw = img.height / img.width * ww
            }
            this.chuli()
        }
        window.addEventListener('resize', (e) => {
            ww = sel.offsetWidth
            if (this.thedirection === 'horizontal') {
                this.fullw = ww
            } else {
                this.fullw = img.height / img.width * ww
            }
            this.chuli()
        })


    },
    props: {

        frontImg: {
            type: String,
            default: '/imgcontrast/1.jpg'
        },
        backImg: {
            type: String,
            default: '/imgcontrast/2.jpg'
        },
        direction: {
            type: String,
            default: 'horizontal'
        },
        color: {
            type: String,
            default: '#3eaf7c'
        }
    }
};
